import { ActionContext } from 'vuex';
import { getStoreAccessors } from 'vuex-typescript';

type BreadcrumbContext = ActionContext<BreadcrumbState, any>;

export interface BreadcrumbChildren {
  link: string;
  name: string;
}

export interface Breadcrumb {
  children?: BreadcrumbChildren[];
  link: string;
  name: string;
}
export interface BreadcrumbState {
  breadcrumb: Breadcrumb[];
  domain: string;
}

const state: BreadcrumbState = {
  breadcrumb: [],
  domain: '',
};

const getters = {
  breadcrumb(s: BreadcrumbState) {
    return s.breadcrumb;
  },
  domain(s: BreadcrumbState) {
    return s.domain;
  },
};

const mutations = {
  clear(s: BreadcrumbState) {
    s.breadcrumb = [];
  },
  push(s: BreadcrumbState, breadcrumbToAdd: Breadcrumb) {
    s.breadcrumb.push(breadcrumbToAdd);
  },

  concat(s: BreadcrumbState, breadcrumbToConcat: Breadcrumb[]) {
    s.breadcrumb = s.breadcrumb.concat(breadcrumbToConcat);
  },
  pop(s: BreadcrumbState) {
    return s.breadcrumb.pop();
  },
  domain(s: BreadcrumbState, domain: string) {
    s.domain = domain;
  },
};

const actions = {
  push(context: BreadcrumbContext, breadcrumbToAdd: Breadcrumb) {
    context.commit('push', breadcrumbToAdd);
  },

  clear(context: BreadcrumbContext) {
    context.commit('clear');
  },

  concat(context: BreadcrumbContext, breadcrumbToConcat: Breadcrumb[]) {
    context.commit('concat', breadcrumbToConcat);
  },

  pop(context: BreadcrumbContext) {
    return context.commit('pop');
  },

  domain(context: BreadcrumbContext, domain: string) {
    context.commit('domain', domain);
  },
};
export const breadcrumb = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
const { dispatch } = getStoreAccessors<BreadcrumbState, any>('app/breadcrumb');

const clear = dispatch(breadcrumb.actions.clear);
const push = dispatch(breadcrumb.actions.push);
const pop = dispatch(breadcrumb.actions.pop);
const setDomain = dispatch(breadcrumb.actions.domain);

export const breadcrumbHelper = {
  clear,
  push,
  pop,
  setDomain,
};
